import { render, staticRenderFns } from "./AttachmentsManageDialog.vue?vue&type=template&id=139ca0e4&scoped=true&"
import script from "./AttachmentsManageDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentsManageDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsManageDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AttachmentsManageDialog.vue?vue&type=style&index=1&id=139ca0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139ca0e4",
  null
  
)

export default component.exports